import { LOGIN, LOGIN_ERROR, FORGOT_PASSWORD, FORGOT_PASSWORD_ERROR, CHANGE_PASSWORD, CLEAR_ALERTS, IS_FETCHING_LOGIN, IS_FETCHING_FORGOT_PASSWORD, RE_SEND_FORGOT_PASSWORD } from "./types";

const LoginReducer = (state, action) => {
    const { payload, type } = action;
    switch (type) {

        case CLEAR_ALERTS:
            return {
                ...state,
                login: {
                    user: null,
                    isFetching: false,
                    error: false,
                    message: '',
                },
                forgotPassword: {
                    isFetching: false,
                    error: false,
                    message: '',
                    user: null,
                    wasReSend: false,
                },
            }

        case IS_FETCHING_LOGIN:
            return {
                ...state,
                login: {
                    user: null,
                    isFetching: true,
                    error: false,
                    message: '',
                },
            }

        case LOGIN:
            return {
                ...state,
                login: {
                    user: payload,
                    isFetching: false,
                    error: false,
                    message: '',
                },
            }

        case LOGIN_ERROR:
            return {
                ...state,
                login: {
                    user: null,
                    isFetching: false,
                    error: true,
                    message: payload
                },
            }

        case FORGOT_PASSWORD:
            return {
                ...state,
                forgotPassword: {
                    wasReSend: false,
                    isFetching: false,
                    error: false,
                    message: '',
                    user: payload,
                },
            }

        case IS_FETCHING_FORGOT_PASSWORD:
            return {
                ...state,
                forgotPassword: {
                    ...state.forgotPassword,
                    isFetching: true,
                    error: false,
                    wasReSend: false
                },
            }

        case FORGOT_PASSWORD_ERROR:
            return {
                ...state,
                forgotPassword: {
                    ...state.forgotPassword,
                    isFetching: false,
                    error: true,
                    wasReSend: false,
                    message: payload
                },
            }

        case RE_SEND_FORGOT_PASSWORD:
            return {
                ...state,
                forgotPassword: {
                    ...state.forgotPassword,
                    isFetching: false,
                    error: false,
                    wasReSend: true,
                },
            }

        case CHANGE_PASSWORD:
            return {
                ...state,
                forgotPassword: {
                    ...state.forgotPassword,
                    wasReSend: false,
                    isFetching: false,
                    error: false,
                    message: '',
                },
            }
        default:
            return state
    }
}

export default LoginReducer